import { render, staticRenderFns } from "./linkedOrgan.vue?vue&type=template&id=5bb588ac"
import script from "./linkedOrgan.vue?vue&type=script&lang=js"
export * from "./linkedOrgan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports